
import { computed, defineComponent, PropType, ref } from 'vue'
import { OrganizationsListModel, useOrganizationModule } from '@/modules/organizations'
import { OrganizationsRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { FormModelCacheTag } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'organizations-list',
    props: {
        organizations: {
            type: Array as PropType<OrganizationsListModel[]>
        },
        filter: {
            type: String
        }
    },
    async setup (props) {
        const router = useRouter()
        const route = useRoute()
        const { getOrganizations, organizationsFilter, organizationsCount } = useOrganizationModule()

        const organizationsColumns = ([
            { name: 'id', label: 'ID', field: 'id', sortable: true, align: 'left' },
            { name: 'companyName', label: 'Company name', field: 'companyName', sortable: true, align: 'left' },
            { name: 'businessId', label: 'Business Id', field: 'businessId', sortable: true, align: 'left' },
            { name: 'contactName', label: 'Contact name', field: 'contactName', sortable: true, align: 'left' },
            { name: 'contactEmail', label: 'Contact email', field: 'contactEmail', sortable: true, align: 'left' },
            { name: 'isSsoOn', label: 'SSO on', field: 'isSsoOn', sortable: true, align: 'left' },
            { name: 'memberCount', label: 'Members amount', field: 'memberCount', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const visibleColumns = ref(['id', 'companyName', 'businessId', 'contactName', 'contactEmail', 'memberCount', 'actions'])

        function onShowOrganization (evt: PointerEvent | null, props: OrganizationsListModel) {
            router.push({ name: OrganizationsRouteNames.SHOW, params: { organizationId: props.id }, query: { page: route.query.page } })
        }

        function onExportToExcel () {
            // TODO: export to Excel
        }

        function onShowMembers (props: OrganizationsListModel) {
            router.push({ name: OrganizationsRouteNames.MEMBERS, params: { organizationId: props.id }, query: { page: '1' } })
        }

        function onShowHistory (props: OrganizationsListModel) {
            // TODO: show organization history
            router.push({ name: OrganizationsRouteNames.SHOW_HISTORY, params: { organizationId: props.id } })
        }

        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)

        const { loading, pagination, onRequest } = useAPIPagination(organizationsFilter, getOrganizations, organizationsCount, currentPage, true, FormModelCacheTag.ORGANIZATIONS_LIST_FILTERS)

        await onRequest({
            filter: props.filter || '',
            pagination: pagination.value
        })

        return {
            organizationsColumns,
            visibleColumns,
            onShowOrganization,
            onExportToExcel,
            onShowMembers,
            onShowHistory,
            pagination,
            loading,
            onRequest
        }
    }
})
